import { DeleteFilled, DeleteOutlined, FormOutlined, PlusOutlined, SwapOutlined, TeamOutlined, CopyOutlined } from "@ant-design/icons";
import React, { useEffect } from "react";
import styled from "styled-components";
import IAction from "../../../interfaces/IAction";
import { CRUDTipo, IMenu, IMenuCRUD, LinkRuta, LinkTipo } from "../../../interfaces/IMenu";
import { COLORS } from "../../constants/colors";
import ButtonGrid from "../ButtonGrid/ButtonGrid";


const ActionsWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    .action {
        margin-left: 2px;
        margin-right: 2px;
    }
    
`;

interface Props {
    menu: IMenu;
    addAction?: IAction;
    updateAction?: IAction;
    deleteAction?: IAction;
    copyAction?: IAction;
    linkUserAction?: IAction;
    linkQuestionAction?: IAction;
}


const ActionsGrid = ({ menu, addAction, updateAction, deleteAction, copyAction, linkUserAction, linkQuestionAction }: Props): JSX.Element => {

    const returnAction = (menuCrud: IMenuCRUD) => {
        let action = <></>;

        switch (menuCrud.crudTipo) {
            case CRUDTipo.Crear:
                action = (
                    <ButtonGrid
                        active={addAction!.active}
                        color={COLORS.blue_active}
                        icon={<PlusOutlined />}
                        method={addAction?.method}
                    />
                );
                break;
            case CRUDTipo.Modificar:
                action = (
                    <ButtonGrid
                        active={updateAction!.active}
                        color={COLORS.yellow_colo1}
                        icon={<FormOutlined />}
                        method={updateAction?.method}
                    />
                );

                break;
            case CRUDTipo.Eliminar:
                action = (
                    <ButtonGrid
                        active={deleteAction!.active}
                        color={COLORS.red_error2}
                        icon={<DeleteOutlined />}
                        method={deleteAction?.method}
                    />
                );
                break;
        }

        return action;
    }


    return (
        <ActionsWrapper>
            <>
                {menu.menuCRUD.map(crud => (
                    <div className="action" key={crud.crudTipoNombre}>
                        {returnAction(crud)}
                    </div>
                ))}
            </>

            {menu.linkTipo === LinkTipo.Modulo && menu.link === LinkRuta.Formularios && (
                <>
                    <div className="action">
                        <ButtonGrid
                            key={'copyAction'}
                            active={copyAction!.active}
                            color={COLORS.blue_main(1)}
                            icon={<CopyOutlined />}
                            method={copyAction?.method}
                            />
                        </div>
                    <div className="action">
                        <ButtonGrid
                            key={'linkUserAction'}
                            active={linkUserAction!.active}
                            color={COLORS.blue_main(1)}
                            icon={<TeamOutlined />}
                            method={linkUserAction?.method}
                        />
                    </div>
                    <div className="action">
                        <ButtonGrid
                            key={'linkQuestionAction'}
                            active={linkQuestionAction!.active}
                            color={COLORS.blue_main(1)}
                            icon={<SwapOutlined />}
                            method={linkQuestionAction?.method}
                        />
                    </div>
                </>
            )}
        </ActionsWrapper>
    );
}

export default ActionsGrid;